import { ApiErrorResponseSchema, ORG_CONTEXT_HEADER } from '@cmoh/shared'
import { env } from '@/config/env'
import { getTabOrganizationId, recoverFromRejectedTabOrganization } from './tab-organization'

const JSON_CONTENT_TYPE = 'application/json'
const CONTENT_TYPE_HEADER = 'Content-Type'

/** `fetch` against the API with cookie credentials and the tab organization header. */
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const organizationId = getTabOrganizationId()
  const headers = new Headers(init.headers)
  if (organizationId) headers.set(ORG_CONTEXT_HEADER, organizationId)

  const response = await fetch(`${env.apiBaseUrl}${path}`, {
    ...init,
    headers,
    credentials: 'include',
  })
  if (!response.ok && organizationId) {
    await recoverIfOrganizationRejected(response.clone(), organizationId)
  }
  return response
}

async function recoverIfOrganizationRejected(
  response: Response,
  organizationId: string,
): Promise<void> {
  if (!response.headers.get(CONTENT_TYPE_HEADER)?.includes(JSON_CONTENT_TYPE)) return
  const body: unknown = await response.json().catch(() => null)
  const parsed = ApiErrorResponseSchema.safeParse(body)
  if (parsed.success) recoverFromRejectedTabOrganization(organizationId, parsed.data.error.code)
}
